module.exports = __webpack_public_path__ + "media/megamenu/Cardkive-f0560a5c.jpg";